import type { CorvidSDKFactory } from '@wix/editor-elements-types/corvid';

type CreateLinkSdkFactory = ({
  linkProperty,
}: {
  linkProperty: string;
}) => CorvidSDKFactory;

export const createLinkSdkFactory: CreateLinkSdkFactory =
  ({ linkProperty }) =>
  ({ props, setProps }) => {
    return {
      get link() {
        return props[linkProperty]?.href;
      },
      set link(value: string) {
        const link = props[linkProperty] ?? {};
        setProps({ [linkProperty]: { ...link, href: value } });
      },
      get rel() {
        return props[linkProperty]?.rel;
      },
      set rel(value: string) {
        const link = props[linkProperty] ?? {};
        setProps({ [linkProperty]: { ...link, rel: value } });
      },
      get target() {
        return props[linkProperty]?.target;
      },
      set target(value: string) {
        const link = props[linkProperty] ?? {};
        setProps({ [linkProperty]: { ...link, target: value } });
      },
    };
  };
